var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreencheckimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM13.22 6.97L8.75 11.44L6.78 9.47C6.63782 9.33752 6.44978 9.2654 6.25548 9.26882C6.06118 9.27225 5.87579 9.35096 5.73838 9.48838C5.60096 9.62579 5.52225 9.81118 5.51882 10.0055C5.5154 10.1998 5.58752 10.3878 5.72 10.53L8.22 13.03C8.36062 13.1704 8.55125 13.2493 8.75 13.2493C8.94875 13.2493 9.13937 13.1704 9.28 13.03L14.28 8.03C14.3537 7.96134 14.4128 7.87854 14.4538 7.78654C14.4948 7.69454 14.5168 7.59522 14.5186 7.49452C14.5204 7.39382 14.5018 7.29379 14.4641 7.2004C14.4264 7.10701 14.3703 7.02218 14.299 6.95096C14.2278 6.87974 14.143 6.8236 14.0496 6.78588C13.9562 6.74816 13.8562 6.72963 13.7555 6.73141C13.6548 6.73318 13.5555 6.75523 13.4635 6.79622C13.3715 6.83721 13.2887 6.89631 13.22 6.97Z",
    fill: "#11895E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheckimg);
export default __webpack_public_path__ + "static/media/greencheckimg.adf6e7aea749329e8d554da7aa294676.svg";
export { ForwardRef as ReactComponent };